export const digitsOnlyErrorKey = 'errors.formFields.digits';

const digitsOnlyRegex = /^[0-9]*$/;

export default function digitsOnly(fieldName) {
  return (value) => {
    if (!value) return;
    if (!value.match(digitsOnlyRegex)) {
      return fieldName ? `${digitsOnlyErrorKey}.${fieldName}` : digitsOnlyErrorKey;
    }
  };
}
